module.exports = __webpack_public_path__ + "img/link.961271cd.svg";